"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToastIconClassName = exports.getToastString = exports.createToast = void 0;

var _uuid = require("uuid");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var ERROR = _constants.toastTypes.ERROR,
    WARNING = _constants.toastTypes.WARNING,
    SUCCESS = _constants.toastTypes.SUCCESS,
    INFO = _constants.toastTypes.INFO;

var getMessageObject = function getMessageObject(data) {
  if (_typeof(data) === 'object' && (data.title || data.message)) {
    return _objectSpread({}, data);
  }

  return {
    message: data
  };
};
/**
 * Returns a new Toast.
 * @param message - Message that appears on the toast.
 * @param type - [ERROR, WARNING, SUCCESS, INFO]
 * @param config - Toast specific configurations. For all properties please visit the documentation and look for Toast props.
 * @returns {Object}
 */


var createToast = function createToast() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var type = arguments.length > 1 ? arguments[1] : undefined;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _objectSpread(_objectSpread({
    id: (0, _uuid.v4)()
  }, getMessageObject(message)), {}, {
    type: type
  }, config);
};
/**
 * Translates the Toast if the given string is a translate object,
 * otherwise return the given string.
 * @param data
 * @param _ - formattedMessage
 * @returns {*}
 */


exports.createToast = createToast;

var getToastString = function getToastString(data, _) {
  if (!data) return null; // If is component

  if (data === null || data === void 0 ? void 0 : data.props) {
    return data;
  }

  if (_typeof(data) === 'object') {
    return data.message ? _(data.message, data.params) : _(data);
  }

  return data;
};
/**
 * Returns the toast icon className.
 * @param type
 * @returns {String}
 */


exports.getToastString = getToastString;

var getToastIconClassName = function getToastIconClassName(type) {
  switch (type) {
    case INFO:
      return 'sbi-toast-info';

    case WARNING:
      return 'sbi-toast-warning';

    case SUCCESS:
      return 'sbi-toast-success';

    case ERROR:
      return 'sbi-toast-error';

    default:
      return 'sbi-toast-info';
  }
};

exports.getToastIconClassName = getToastIconClassName;
//# sourceMappingURL=utils.js.map